import React from 'react'

import AlmaBetter from "../assets/almalogo.png"


export const Header = () => {
  return (
    <div className="w-20 ml-5 mt-2">
    <img src={AlmaBetter} alt="Logo"/>
  </div>
  )
}
